<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="工程名称:" prop="project_name">
                  <el-input v-model="form.project_name"/>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="建设单位:" prop="constructionUnit">
            <el-input v-model="form.construction_unit"/>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="审计报告编号:" prop="audit">
            <el-input v-model="form.audit"/>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24" class="action" style="margin-bottom:20px">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button size="small" type="primary" @click="handleOpenDetail({})">新建</el-button>
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #action="record">
          <a class="success" href="javascript:;" @click="handleOpenDetail(record.row)">编辑</a>
          <a class="delete" href="javascript:;" @click="handleDelete(record.row)">删除</a>
      </template>
    </STable>
    <ItemMoudle :visible.sync='visible' :record='record' @submitForm='submitForm' />
  </div>
</template>

<script>
import { IrrigationWorks } from '@/api/datamanagement'
import STable from '@/components/STable';
import ItemMoudle from './modules/ItemMoudle.vue';
export default {
  components: {
    STable,
    ItemMoudle
  },
  data () {
    return {
      form: {
        project_name: '',
        construction_unit: '',
        audit: ''
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '工程名称',
          prop: 'project_name',
          ellipsis: true,
          width: 400
        },
        {
          label: '建设单位',
          // align: 'center',
          prop: 'construction_unit',
          ellipsis: true,
          width: 350
        },
        {
          label: '中标项目经理',
          prop: 'win_project_leader',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '中标合同价(万元)',
          prop: 'win_contract_price',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '中标合同工期',
          prop: 'win_contract_date',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '实际竣工验收日期',
          prop: 'actual_acceptance_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '送审金额(元)',
          prop: 'first_censorship_amount',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '终审价(元)',
          prop: 'last_instance_amount',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '终审定价日期',
          prop: 'last_instance_date',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '审计报告编号',
          prop: 'audit',
          // align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          label: '备注',
          prop: 'remark',
          width: 250,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const arr = []
        for (var key in this.form) {
          if (this.form[key]) {
            arr.push({
              columnName: key,
              columnValue: this.form[key],
              filterType: 3,
              tableName: 'oa_form_irrigation_works'
            })
          }
        }
        return IrrigationWorks.getList(this, {datasourceId: '1631134616704258048', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      visible: false,
      record: {}
    }
  },
  methods: {
    handleDelete (record) {
      this.$confirm('是否删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        IrrigationWorks.deleteIrrigationWorks(this, {datasourceId: '1631134616704258048', dataId: record.id}).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.submitForm(false)
        })
      })
    },
    handleOpenDetail (record) {
      this.record = record
      this.visible = true
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {
        winId: '',
        constructionUnit: '',
        audit: ''
      }
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/element-variables.scss';
  .title {
    border: 1px solid #EDEDED;
    border-left-width: 5px;
    border-left-color: $--color-primary;
    margin-bottom: 20px;
  }

  .title p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin: 0px;
    padding-left: 20px;
  }

  .title p span {
    font-size: 20px;
    color: $--color-primary;
  }

  .item-list {
    margin: 0px;
  }
  .item-list li {
    margin: 10px 0px;
  }

  .item {
    height: 48px;
    display: flex;
    align-items: center;
  }
</style>
